import customSelectStyles from "components/CustomSelect/CustomSelectStyle"
import Toast from "components/Toast"
import { MocUserRole } from "core/services/models/Enums"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router"
import { useLocation } from "react-router-dom"
import Select from "react-select"
import Button from "../../../../components/Button"
import InputField from "../../../../components/InputField"
import { addNewReferralDoctor, getAllCenters, getConsultantReferralDetailsById, updateContactReferrals } from "../../../../core/services/api"
import "./AddNewReferral.scss"

function AddNewReferral() {
  const history = useHistory()
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly);
  readOnly = true;
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)

  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState<any>({})
  const [formErrors, setFormErrors] = useState<any>()
  const location = useLocation()
  let id = location?.state?.idValue
  const [displayToast, toggleToast] = useState<any>()
  const [doctorReferralInfo, setDoctorReferralInfo] = useState<any>({
    name: "",
    specialization: "",
    phone: "",
    email: "",
    centerIds: []
  })
  const [centerOptions, setCenterOptions] = useState<any>([])
  const [isMenuOpen, setIsMenuOpen] = useState<any>(false)

  useEffect(() => {
    getAllCenters().then((res: any) => {
      const centerDetailsArray = res.map((c: any) => {
        return {
          label: c?.centerName,
          value: c?.id,
        }
      })
      setCenterOptions(centerDetailsArray)
    })
  }, [])

  useEffect(() => {
    if (id) {
      getConsultantReferralDetailsById(`${id}`)
        .then((res) => {
          setDoctorReferralInfo({
            name: res.consultantName,
            specialization: res.specialization,
            phone: res.phoneNumber,
            email: res.emailId,
            centerIds: res?.centerIds
          })
          // toggleToast({
          //   type: "success",
          //   text: 'Data Saved Successfully',
          // })

        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [id])

  useEffect(() => {
    if (!id && !resData?.id) {
      if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
        let referralDoctorDetail: any = {
          consultantName: doctorReferralInfo.name,
          phoneNumber: doctorReferralInfo.phone,
          emailId: doctorReferralInfo.email,
          specialization: doctorReferralInfo.specialization,
          centerIds: userRole === MocUserRole.CENTER_ADMIN ? [userDetail?.currentCenter?.centerId] : doctorReferralInfo?.centerIds
        }
        addNewReferralDoctor(referralDoctorDetail)
          .then((data) => {
            setResData(data)
            id = data?.id
            toggleToast({
              type: "success",
              text: 'Data Saved Successfully',
            })

          })
          .catch((err) => {
            console.log(err)
          })
      }
      return
    } else {
      if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
        let updateContactReferralsReq: any = {
          consultantName: doctorReferralInfo.name,
          phoneNumber: doctorReferralInfo.phone,
          emailId: doctorReferralInfo.email,
          specialization: doctorReferralInfo.specialization,
          centerIds: doctorReferralInfo?.centerIds
        }
        updateContactReferrals(id, updateContactReferralsReq)
          .then((data) => {
            toggleToast({
              type: "success",
              text: 'Updated Successfully',
            })
            // history.push(`/ContactReferrals`)
          })
          .catch((err) => {
            console.log("err", err)
          })
      }
    }
  }, [formErrors])

  const validate = (values: any) => {
    const errors: any = {}
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!values.name) {
      errors["name"] = "Name is required"
    }
    if (values.email && !regex.test(values.email)) {
      errors["email"] = "This is not a valid email format!"
    }
    if (userRole !== MocUserRole.CENTER_ADMIN) {
      if (values?.centerIds?.length < 1) {
        errors["centerIds"] = "Location is required"
      }
    }
    return errors
  }

  const handleSubmit = (e: any) => {
    e.preventDefault()
    setFormErrors(validate(doctorReferralInfo))
    setIsSubmit(true)
  }

  return (
    <div className="add-new-referral-container">
      <div className="add-new-referral-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push('/contactReferrals')
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="add-new-text">Add New Referral Doctor</div>

      </div>
      <div className="add-new-referral-details">
        <form onSubmit={handleSubmit}>
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">* Name: </label>
            </div>

            <div className="col-3">
              {readOnly}
              <InputField
                placeholder="Name"
                value={doctorReferralInfo?.name}
                handleChange={(e) =>
                  setDoctorReferralInfo({
                    ...doctorReferralInfo,
                    name: e.target.value,
                  })
                }
                // readOnly={readOnly}
                errorMsg={formErrors?.name}
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Specialization:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Specialization"
                value={doctorReferralInfo.specialization}
                handleChange={(e) =>
                  setDoctorReferralInfo({
                    ...doctorReferralInfo,
                    specialization: e.target.value,
                  })
                }
              // readOnly={readOnly}
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Phone:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Phone"
                value={doctorReferralInfo.phone}
                // readOnly={readOnly}
                handleChange={(e: any) => {
                  const value = e.target.value
                  let res = ""
                  value?.split("")?.forEach((ele: any) => {
                    let k = ele?.charCodeAt(0)
                    if (k >= 48 && k <= 57) {
                      res += ele
                    }
                  })
                  if (res?.length <= 10) {
                    setDoctorReferralInfo({
                      ...doctorReferralInfo,
                      phone: res,
                    })
                  }
                }}
              // }
              // type="number"
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-2">
              <label className="textlabel">Email:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Email"
                // readOnly={readOnly}
                value={doctorReferralInfo.email}
                handleChange={(e) =>
                  setDoctorReferralInfo({
                    ...doctorReferralInfo,
                    email: e.target.value,
                  })
                }
                errorMsg={formErrors?.email}
              />
            </div>
          </div>
          {
            userRole !== MocUserRole.CENTER_ADMIN && (
              <div className="row nameDetails">
                <div className="col-2">
                  <label className="textlabel">* Location:</label>
                </div>
                <div className="col-3">
                  <Select
                    // isDisabled={readOnly}
                    styles={customSelectStyles()}
                    value={centerOptions.filter((item: any) => doctorReferralInfo?.centerIds?.includes(item?.value))}
                    placeholder="Select Location"
                    isSearchable={true}
                    options={centerOptions}
                    onChange={(option: any) => {
                      const selected: any = option?.map((e: any) => e?.value)
                      setDoctorReferralInfo({
                        ...doctorReferralInfo,
                        centerIds: selected,
                      })
                    }}
                    onFocus={() => {
                      setIsMenuOpen(true)
                    }}
                    onBlur={() => {
                      setIsMenuOpen(false)
                    }}
                    menuIsOpen={isMenuOpen}
                    isMulti
                  />
                  {formErrors?.centerIds && (
                    <span className="error">{formErrors?.centerIds}</span>
                  )}
                </div>
              </div>
            )
          }
          <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                type={"button"}
                // disabled={readOnly}
                outline={true}
                onClick={() => history.push(`/contactReferrals`)}
                id="cancel"
              />
            </div>
            <div>
              <Button text="Save" type="submit" id="save" />
            </div>
          </div>
        </form>
      </div>
      {displayToast && (
        <Toast
          textMessage={displayToast?.text}
          onClose={() => {
            toggleToast(false)
            history.push("/ContactReferrals")
          }}
          onCloseText={"Close"}
          onClickText={null}
          onClick={() => history.push("/ContactReferrals")}
          type={displayToast?.type}
        />
      )
      }
    </div>
  )
}
export default AddNewReferral
